import { Card } from '@mui/material';
import Typography from 'component/MarketPlace/Typography/Typography';
import styled from 'styled-components';

const maxLine = (max: number) => `
  display: -webkit-box;
  -webkit-line-clamp: ${max};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const StyledAppCard = styled(Card)(({ theme }) => `
  width: 100%;
  height: 160px;
  padding: ${theme.uptimeSpace[10]}px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${theme.uptimeColors.grayScales.white};
  box-shadow: 0px 0px 0px 1px ${theme.uptimeColors.grayScales.boxShadow} !important;
  &:hover {
    box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16),  0 3px 6px 0 rgba(0, 0, 0 , 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09) !important;
  }
  &.MuiPaper-rounded {
    border-radius: 10px;
  }
`);

export const StyledTitle = styled(Typography)(({ theme }) => `
  ${maxLine(1)}
`);